import * as React from 'react'

import {TwitterShareButton, FacebookShareButton, LinkedinShareButton} from 'react-share'

const Share = ({url, title, twitterHandle}) => (
	<div className="flex justify-start items-center mt-4 ">
		<div className="grow border-2 border-tertiary"></div>
		{/* <span className="mr-5 text-md md:text-xl font-normal md:font-medium uppercase opacity-70 leading-10">
			Share article
		</span>
		<TwitterShareButton
      url={url}
      title={title}
      via={twitterHandle.split('@').join('')}
      className="mr-4 hover:text-quarternary cursor-pointer"
    >
      Twitter
    </TwitterShareButton>
    <FacebookShareButton
      url={url}
      quote={title}
      via={twitterHandle.split('@').join('')}
      className="mr-4 hover:text-quarternary cursor-pointer"
    >
      Facebook
    </FacebookShareButton> */}
	</div>
)

export default Share